import type { FC } from 'react'

import type { IncomeProperties } from '@/types/Income'

interface Props {
  incomeProperties: IncomeProperties
}

const DeclaredIncome: FC<Props> = ({ incomeProperties }) => (
  <>
    {incomeProperties.currency?.symbol}
    {incomeProperties.value.toFixed(2)}{' '}
    <span>
      paid <strong>{incomeProperties.frequency}</strong>{' '}
      {incomeProperties.averageHoursAWeek && (
        <span>({incomeProperties.averageHoursAWeek}hrs a week on average)</span>
      )}
    </span>
  </>
)

export default DeclaredIncome
